import * as types from '../actions/actionTypes';
import initialState from './initialState';
    
        
export default function tagReducer(state= initialState.tag, action){
    let newState;
     
	switch(action.type){
         case types.LOAD_TAG_LIST_SUCCESS:	
             action.tag.filtroActivo=state.filtroActivo;
            action.tag.filtroActual=state.filtroActual;
            action.tag.showActivos=state.showActivos;
			 
            return action.tag;

        case types.BORRAR_TAG_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(tag => tag.id !== action.tag.id)];          
			return newState;    
            
        case types.ACTIVAR_TAG_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(tag => tag.id !== action.tag.id)];          
			 return newState;
            
        case types.SET_FILTRO_TAG:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}